import { Fragment, useEffect, useState } from "react";
import { Button, Container } from 'react-bootstrap';
import { FaLaugh } from 'react-icons/fa';
import { FaArrowRight } from 'react-icons/fa6';
import { useToast } from '../../../context';
import { useGetAllTeamProfilesQuery } from '../../../services/endpoints/website/teamProfile';
import { GetQueryParams } from '../../../types/api.type';
import { SFCLocation } from '../../../types/place.types';
import { TeamProfile } from '../../../types/website.types';
import '../FranchiseLayout.css';
interface FranchiseProps {
  location: SFCLocation | undefined;
}
const defaultScope = '';

export const OurCrewSubpage: React.FC<FranchiseProps> = ({ location }) => {
  const { addToast } = useToast();
  const filters: GetQueryParams = location?.id
    ? {
        scope: defaultScope,
        data: {
          entries: 1000,
          filterBy: [{ field: 'location_id', operator: 'equals', value: location.id }]
        }
      }
    : { scope: defaultScope, data: { entries: 1000 } };
  const { data, error, isLoading } = useGetAllTeamProfilesQuery(filters);
  const [crew, setCrew] = useState<TeamProfile[]>([]);

  useEffect(() => {
    if (error) {
      addToast('Error while loading data', 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, isLoading]);

  useEffect(() => {
    if (data && data.results) {
      setCrew(data.results);
    }
  }, [data]);

  return (
    <Container className="text-blue pb-5">
      <div className="col-12 d-flex justify-content-center flex-nowrap">
        <div className="franchise-find-classes-btn">
          <Button
              className="text-uppercase bg-orange mb-5 px-5 py-3"
              onClick={() => window.scrollTo(0, 0)}
              href={
  location?.latitude != null && location?.longitude != null
    ? `/sessions?origin=${location.latitude}_${location.longitude}`
    : '/sessions'
}          >
            Find Our Classes
            <FaArrowRight
                className="ms-2"
                size={22}
            />
          </Button>
        </div>
      </div>

      <div className="div-masonry-2-column">
        {crew.map((team_profile, index) => (
          <Fragment key={`crew-${team_profile.id}`}>
            <div className="div-masonry-content testimonial-card">
              <img
                src={
                  (team_profile as TeamProfile & { signed_url?: string }).signed_url ||
                  (team_profile.s3_base_url && team_profile.image_file_name
                    ? `${team_profile.s3_base_url}/${team_profile.image_file_name}`
                    : undefined)
                }
                alt=""
                className="image-bio green"
              />
              <div className="subheader">{team_profile.title}</div>
              <h3>{team_profile.name}</h3>
              <div className="div-quotation">
                <div
                  className="text-bio"
                  dangerouslySetInnerHTML={{ __html: team_profile.description }}
                ></div>
                {team_profile.quote_type === 'joke' ? (
                  <Fragment key={`crew-${team_profile.id}`}>
                    <div className="d-flex align-items-center">
                      <div className="text-fa pun">
                        <FaLaugh size={16} />
                      </div>
                      <div className="pun">
                        <em>Favorite Food Joke</em>
                      </div>
                    </div>
                    <div className="small">{team_profile.quote}</div>
                  </Fragment>
                ) : (
                  <blockquote className="block-quote bio">
                    <em>{team_profile.quote}</em>
                  </blockquote>
                )}
              </div>
            </div>
          </Fragment>
        ))}
      </div>
    </Container>
  );
};
